import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { loadableReady } from '@loadable/component';

import { App } from '../common/App';
import { client } from './__graphql__/client';
import { ThemeProvider } from 'styled-components';
import { theme } from './theme';

const Client: React.FC = () => {
  return (
    <HelmetProvider>
      <ApolloProvider client={client}>
        <BrowserRouter basename={window.__ENV__.baseURL || '/'}>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </BrowserRouter>
      </ApolloProvider>
    </HelmetProvider>
  );
};

loadableReady(() => {
  ReactDOM.render(<Client />, document.getElementById('root'));
});
